module.exports = __webpack_public_path__ + "static/media/puma.811e081c.png";